import { render } from "./SuggestUserModal.vue?vue&type=template&id=fe2f5792"
import script from "./SuggestUserModal.vue?vue&type=script&lang=js"
export * from "./SuggestUserModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__